import { render } from "./BasketComponent.vue?vue&type=template&id=25cdb9af"
import script from "./BasketComponent.vue?vue&type=script&lang=js"
export * from "./BasketComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\src\\Nordlux.Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__